import { useEffect, useState,useContext } from "react";
import { toast } from "react-toastify";
import { getDocumentsTable, createDocumentsDetails, updateDocumentsDetails } from "../../../Utility/Api";
import { WarehouseContext } from '../../../Utility/UserContext';





export const EditDocumentDetails = ({ showModal, setShowModal, fetchDocumentDetails, selectedDocumentDetails, fetchdata, AddorEdit, setselectedDocumentDetails }) => {

    const { showLoader, hideLoader,UserItem,shopItem } = useContext(WarehouseContext);

    const [formData, setFormData] = useState({ document_id: '', category_id: '', status: '' });
    const [DocumentsTable, setDocumentsTable] = useState([]);

    const [errors, setErrors] = useState({})

    useEffect(() => {
        fetchDocumentTable();
        console.log(selectedDocumentDetails);


        if (selectedDocumentDetails) {
            setFormData({
                document_id: selectedDocumentDetails?.document_id || '',
                document_url: selectedDocumentDetails?.document_url || '',
                issued_date: selectedDocumentDetails?.issued_date || '',
                expiry_date: selectedDocumentDetails?.expiry_date || '',
                date: selectedDocumentDetails?.date || '',
                created_by_id: selectedDocumentDetails?.created_by_id || '',
                status: selectedDocumentDetails?.status?.toString() || '',
            });
        } else {
            setFormData({ document_id: '', document_url: '', issued_date: '', expiry_date: '', date: '', created_by_id: '', status: '' });
        }
    }, [selectedDocumentDetails]);

    const fetchDocumentTable = async () => {
        try {
            const response = await getDocumentsTable();
            if (response.data.data) {
                console.log(response);
                setDocumentsTable(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching Documents Details data:', error);
        }
    };

    const handleSubmit = async (e) => {
        showLoader()
        e.preventDefault();
        const validationErrors = {};

        if (!formData.document_id) {
            validationErrors.document_id = "document  is required.";
        }
        if (!formData.document_url) {
            validationErrors.document_url = "document url  is required.";
        }
        if (!formData.issued_date) {
            validationErrors.issued_date = "issued date   is required.";
        }
        if (!formData.expiry_date) {
            validationErrors.expiry_date = "expiry date   is required.";
        }
        if (!formData.date) {
            validationErrors.date = "date   is required.";
        }
        if (!formData.created_by_id) {
            validationErrors.created_by_id = "date   is required.";
        }



        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            hideLoader()
            return;
        }


        const payload = {
            document_id: formData.document_id,

            document_url: formData.document_url,
            issued_date: formData.issued_date,
            expiry_date: formData.expiry_date,
            date: formData.date,
            created_by_id: UserItem?.user_id,
            created_by:UserItem?.user_id,
            shop_id: shopItem?.shop_id,
            status: !selectedDocumentDetails ? '1' : formData.status,
        };

        console.log('Payload being sent:', payload);
        try {
            if (AddorEdit) {
                await createDocumentsDetails(payload);
                    
                hideLoader()
                toast.success('Documents Details Added successfully');
                fetchDocumentDetails();


            } else {
                await updateDocumentsDetails(selectedDocumentDetails?.document_details_id, payload);
                hideLoader()
                toast.success('Documents Details Updated successfully');
                fetchDocumentDetails();

            }
            setShowModal(false);
            fetchdata();
        } catch (error) {
            console.error('Error Documents Details data:', error);
            hideLoader()

        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    const handleCancel = () => {
        setShowModal(false);
        setFormData({
            document_id: '', document_url: '', issued_date: '', expiry_date: '', date: '', created_by_id: '', status: ''
        });
        setselectedDocumentDetails()
    };



    return (
        <>
            {showModal && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>{selectedDocumentDetails ? 'Edit  Documents Details' : 'Add Documents Details'}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() => handleCancel()}
                                ></button>
                            </div>
                            <div className="modal-body" style={{ fontFamily: "poppins" }}>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group mb-3">
                                        <label>Document Url</label>
                                        <div className="col-12">
                                            <input
                                                type="text"
                                                name="document_url"
                                                value={formData.document_url}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                            {errors.description && (
                                                <small className="text-danger">{errors.document_url}</small>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label>Document Table</label>
                                        <div className="col-12">
                                            {DocumentsTable.length > 0 && (
                                                <select
                                                    name="document_id"
                                                    value={formData.document_id}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                >
                                                    <option value="">Select Document Table</option>
                                                    {DocumentsTable?.map((cat) => (
                                                        <option key={cat.id} value={cat.document_id}>
                                                            {cat.title}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}

                                            {errors.document_id && (
                                                <small className="text-danger">{errors.document_id}</small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="form-group mb-3">
                                        <label>Issued Date</label>
                                        <div className="col-12">
                                            <input
                                                type="date"
                                                name="issued_date"
                                                value={formData.issued_date}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                            {errors.description && (
                                                <small className="text-danger">{errors.issued_date}</small>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label>Expiry Date</label>
                                        <div className="col-12">
                                            <input
                                                type="date"
                                                name="expiry_date"
                                                value={formData.expiry_date}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                            {errors.description && (
                                                <small className="text-danger">{errors.expiry_date}</small>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label>date</label>
                                        <div className="col-12">
                                            <input
                                                type="date"
                                                name="date"
                                                value={formData.date}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                            {errors.date && (
                                                <small className="text-danger">{errors.date}</small>
                                            )}
                                        </div>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label>created by</label>
                                        <div className="col-12">
                                            <input
                                                type="text"
                                                name="created_by_id"
                                                value={formData.created_by_id}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                            {errors.created_by_id && (
                                                <small className="text-danger">{errors.created_by_id}</small>
                                            )}
                                        </div>
                                    </div>

                                    {selectedDocumentDetails &&
                                        <div className="form-group mb-3">
                                            <label>Status</label>
                                            <select
                                                name="status"
                                                value={formData.status}
                                                onChange={handleChange}
                                                className="form-control"
                                                required
                                            >
                                                <option value="" disabled>Select Status</option>
                                                <option value="1">Active</option>
                                                <option value="0">Inactive</option>
                                            </select>
                                        </div>}
                                    <button type="submit" className="btn btn-success float-end">
                                        {selectedDocumentDetails ? 'Update Document Details' : 'Add Document Details'}
                                    </button>
                                    &nbsp;&nbsp;
                                    <button
                                        type="button"
                                        className="btn btn-secondary ml-2 float-end me-1"
                                        onClick={() => handleCancel()}
                                    >
                                        Cancel
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}</>

    )
}
